import styled, { css } from 'styled-components';

export const visibilityAnimationRight = css`
  &.animated {
    right: 0;
    opacity: 1;
    transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

export const maxWidthModalCreateJourney = '526px';

export const WrapperContentModal = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: ${maxWidthModalCreateJourney};
    background-color: ${theme.color.background.neutral.default};
    position: fixed;
    top: 0;
    right: -100%;
    height: 100%;
    overflow-y: auto;
    opacity: 1;
    transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);

    padding: ${theme.spacing.km6} ${theme.spacing.km8} 120px
      ${theme.spacing.km8};
  `}

  ${visibilityAnimationRight}
`;

export const Strong = styled('strong')`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.default};
    font-weight: ${theme.font.weight.bold};
  `}
`;
